import {DataObjectId} from 'yougile-model'
import {getRightUrl} from '@extensions/web-platform/get-right-url'
import {UIElement} from '../ui-element'

export class ImageEl extends UIElement {
  private uiSrc: string
  private uiAlt = ''
  public override uiTag = 'img'

  constructor(companyId: DataObjectId, src: string) {
    super(companyId, undefined, undefined)
    this.uiSrc = getRightUrl(src)
  }

  public get src(): string {
    return this.uiSrc
  }

  public set src(val: string) {
    this.uiSrc = val
    this.refresh()
  }

  public get alt(): string {
    return this.uiAlt
  }

  public set alt(val: string) {
    this.uiAlt = val
    this.refresh()
  }

  public override render(el: HTMLImageElement): void {
    el.innerHTML = ''
    el.className = 'ui-image'
    el.src = this.uiSrc
    el.alt = this.uiAlt
    super.render(el)
  }
}
